import { call, put, takeEvery, select } from "redux-saga/effects"
import {
  GET_WIDGETS_BY_PAGE_ID,
  CREATE_WIDGET,
  DUPLICATE_WIDGET_TO_ANOTHER_PAGE,
} from "./constants"

import { getWidgetsByPageIdSuccess } from "./actions"

import { selectCurrentToken } from "Containers/Login/selectors.js"

import {
  setSuccessMessage,
  setErrorMessage,
  removeErrorMessage,
  removeSuccessMessage,
} from "Containers/Messages/actions"

import {
  responseTypeIsError,
  responseTypeIsSuccess,
  manageErrorGenerator,
  manageSuccessGenerator,
} from "Containers/App/saga"

import { getCors, postCors } from "Utils/rulesCors"

// Utils
import { config } from "Utils/config"
import request from "Utils/request"

function* getWidgetsByPageIdSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }

  const { API_URL } = config
  const requestURL = `${API_URL}/widgetsByPageId/${payload.pageId}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      yield put(getWidgetsByPageIdSuccess(response.data))
    }
  } catch (err) {
    console.error("[route] => /widgetsByPageId/:pageId => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* createWidgetSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }

  const { API_URL } = config
  const requestURL = `${API_URL}/widgets`

  try {
    const response = yield call(request, requestURL, postCors(payload, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
      //yield put(getWidgetsByPageIdSuccess(response.data))
    }
  } catch (err) {
    console.error("[route] => /widgets => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* duplicateWidgetAnotherPageSaga({ payload }) {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { API_URL } = config
  const requestURL = `${API_URL}/duplicateWidgetToAnotherPage`

  try {
    const response = yield call(request, requestURL, postCors(payload, specificHeaders))
    if (responseTypeIsError(response))
      yield call(manageErrorGenerator, { response, showMessageToUser: true })
    else {
      if (responseTypeIsSuccess(response))
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
    }
  } catch (err) {
    console.error("[route] => /widgets => ERROR => ", err)
    yield put(setErrorMessage(err))
  }
}

function* widgetsSaga() {
  yield takeEvery(GET_WIDGETS_BY_PAGE_ID, getWidgetsByPageIdSaga)
  yield takeEvery(CREATE_WIDGET, createWidgetSaga)
  yield takeEvery(DUPLICATE_WIDGET_TO_ANOTHER_PAGE, duplicateWidgetAnotherPageSaga)
}

export default widgetsSaga
